import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

//front door
import { LoginComponent } from './frontdoor/login/login.component';
import { SignupComponent } from './frontdoor/signup/signup.component';
import { ForgotComponent } from './frontdoor/forgot/forgot.component';
import { ResetComponent } from './frontdoor/reset/reset.component';

//obligatory pages
import { AboutusComponent } from './obligatorypages/aboutus/aboutus.component';
import { MysettingsComponent } from './obligatorypages/mysettings/mysettings.component';


//pages
import { MyproductsComponent } from './pages/myproducts/myproducts.component';

import { PublicLandingComponent } from './shared/landings/public-landing/public-landing.component';

import { DashboardGridComponent } from './utilities/dashboard-grid/dashboard-grid.component';

import { ContactComponent } from './obligatorypages/contact/contact.component';
import { SupportComponent } from './obligatorypages/support/support.component';
import { ForyouComponent } from './pages/foryou/foryou.component';
import { TosComponent } from './obligatorypages/tos/tos.component';


//pages shared
import { MyaccountComponent } from './obligatorypages/myaccount/myaccount.component';




import { AdminDashboardComponent } from './adminTools/admin-dashboard/admin-dashboard.component';

import { LandingPageComponent } from './shared/landings/landing-page/landing-page.component';

import { AdminComponent } from './adminTools/admin/admin.component';

import { PersonalDashboardComponent } from './pages/personal-dashboard/personal-dashboard.component';
import { FamilyComponent } from './pages/family/family.component';
import { AllmyhugsComponent } from './pages/allmyhugs/allmyhugs.component';
import { NorametricsComponent } from './pages/norametrics/norametrics.component';
import { NewsrespondersComponent } from './pages/newsresponders/newsresponders.component';
import { MonasteryComponent } from './pages/monastery/monastery.component';
import { EducationComponent } from './pages/education/education.component';
import { TravelComponent } from './pages/travel/travel.component';
import { CommunitydevComponent } from './pages/communitydev/communitydev.component';
import { RemotecareerboardComponent } from './pages/remotecareerboard/remotecareerboard.component';
import { BizbasebeginComponent } from './pages/bizbasebegin/bizbasebegin.component';
import { LifebasebeginComponent } from './pages/lifebasebegin/lifebasebegin.component';
import { AntisocialmediaComponent } from './pages/antisocialmedia/antisocialmedia.component';
import { HowjyadoitComponent } from './pages/howjyadoit/howjyadoit.component';
import { LobbyhobbiesComponent } from './pages/lobbyhobbies/lobbyhobbies.component';
import { HopesanddreamsComponent } from './pages/hopesanddreams/hopesanddreams.component';


const routes: Routes = [
  {
    path: 'dashboard',
    component: PersonalDashboardComponent,
    children: [
      { path: '', component: DashboardGridComponent },  // Default or “grid” content
      { path: 'family', component: FamilyComponent },
      { path: 'allmyhugs', component: AllmyhugsComponent },
      { path: 'norametrics', component: NorametricsComponent },
      { path: 'newsresponders', component: NewsrespondersComponent },
      { path: 'monastery', component: MonasteryComponent },
      { path: 'education', component: EducationComponent },
      { path: 'travel', component: TravelComponent },
      { path: 'community', component: CommunitydevComponent },
      { path: 'remotecareerboard', component: RemotecareerboardComponent },
      { path: 'bizbasebegin', component: BizbasebeginComponent },
      { path: 'lifebasebegin', component: LifebasebeginComponent },
      { path: 'antisocialmedia', component: AntisocialmediaComponent },
      { path: 'howdjyadoit', component: HowjyadoitComponent },
      { path: 'mylobbyofhobbies', component: LobbyhobbiesComponent },
      { path: 'hopesanddreams', component: HopesanddreamsComponent }
    ]
  },
  //{ path: '', component: DashboardGridComponent }, 
  
  //front door
  { path: 'login', component: LoginComponent },
  { path: 'signup', component: SignupComponent },
  { path: 'forgot', component: ForgotComponent },
  { path: 'reset', component: ResetComponent },

  //public area

  //obligatory pages
    { path: 'AboutUs', component: AboutusComponent },
    { path: 'ContactUs', component: ContactComponent },
    { path: 'Support', component: SupportComponent },
    { path: 'myaccount', component: MyaccountComponent },
    { path: 'tos', component: TosComponent },
    { path: 'faq', component: MyaccountComponent },
    { path: 'mysettings', component: MysettingsComponent },

  // shared components

  //pages
  { path: 'myproducts', component: MyproductsComponent },
  { path: 'admin', component: AdminComponent},
  //landings
  { path: 'landing', component: LandingPageComponent },
  
  { path: 'myaccount', component: MyaccountComponent },
  //{ path: 'mysettings', component: MyaccountComponent },
  { path: 'mysettings', component: MysettingsComponent},
  
  { path: 'photoalbums', component: MyaccountComponent },
  { path: 'foryou', component: ForyouComponent },
  

  { path: 'dashboard2', component: AdminDashboardComponent },

 


/*
{ path: 'allmyhugspreview',
component: HugmakerComponent,
canActivate: [AuthGuard],
data: { requiredRoles: ['SuperAdmin', 'allmyhugs'] }
},
*/





  // If someone just hits '/', we can redirect to 'dashboard'
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  // A catch-all:
  { path: '**', redirectTo: 'dashboard' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
